import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectedLanguage, setLanguage } from "../locales";
import { Button } from "antd";

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [i18n]);

  const changeLanguage = (lng: string) => {
    setLanguage(lng);
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6">
        <div className="flex gap-4 justify-center">
          <span
            className="cursor-pointer hover:text-gray-400 mt-5"
            onClick={() => changeLanguage("en")}
          >
            English
          </span>
          <span
            className="cursor-pointer hover:text-gray-400 mt-5"
            onClick={() => changeLanguage("kz")}
          >
            Қазақша
          </span>
        </div>

        <div className="text-center text-sm text-gray-400 mt-3">
          <p>&copy; {new Date().getFullYear()} ZhadigerAI</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
